var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bank-information-page"},[_c('v-container',{staticClass:"main-container responsive-height"},[_c('v-row',{attrs:{"dense":""}},[_c('v-col',{staticClass:"position-relative",attrs:{"cols":"12"}},[_c('BankInfoAllTabs'),_c('div',{staticClass:"bank-dropdown"},[_c('DropdownMenu')],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }